<template>
  <div id="wrapper">
    <div id="page-wrapper" class="light-gray-bg dashbard-1" v-if="isMatchPath">
      <!-- MainView -->
      <article @click.self="open = false" class="wrapper wrapper-content main-column full-column">
        <!-- ViewTitleBox -->
        <div class="ibox-tools view-title">
            <h1 class="info-menu view-name">
                <img src="static/img/assets/nav_people_on.png" alt="">
                {{$t('searchUserStr')}}
            </h1>
            <span class="info-right">
            </span>
        </div>
        <!-- /ViewTitleBox -->
        <section class="animated fadeInRight">
          <!-- 1on1item -->
          <div class="ibox">
            <div class="ibox-content">
                <!-- ユーザー検索ボックス -->
                <div class="ibox-title search-box">
                  <div class="row">
                    <div class="col-sm-12">
                      <form @submit.prevent>
                        <div class="input-group">
                          <input v-model="searchText" type="text" class="typeahead_2 form-control" :placeholder="$t('searchWithUserName')">
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="ibox-content search-resultview">
                    <ul v-if="searchText == ''">
                        <li><label>{{$t('checkUserStrType')}}</label></li>
                        <li v-if="this.getVisitedUsers.length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                        <li v-for="user in getVisitedUsers" :key="user.id" v-if="user && user.userInfo && user.userId !== getUserId" class="result-box">
                          <router-link :to="{ name: 'User', params: { userId: user.userId }}">
                            <div class="cursor">
                              <span class="search-userimg">
                                <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                              </span>
                              <div class="search-userinfo">
                                <span class="search-username">{{ user.userInfo.userName }}</span>
                                <span class="search-userdept">{{ user.userInfo.dept }}</span>
                              </div>
                            </div>
                          </router-link>
                        </li>
                        <!-- </transition-group> -->
                    </ul>
                    <ul v-else>
                      <li><label>{{$t('searchResuleStrType')}}</label></li>
                      <li v-if="Object.keys(this.getUsersBySearchText).length === 0" class="full-cell"><label>{{$t('notFoundUserStr')}}</label></li>
                        <li v-for="(user, key) in getUsersBySearchText" :key="user.id" v-if="user && user.userInfo && key !== getUserId" class="result-box">
                          <router-link :to="{ name: 'User', params: { userId: key }}">
                            <div class="cursor">
                              <span class="search-userimg">
                                <img v-if="user.userInfo.userIcon" :src="user.userInfo.userIcon" alt="image" class="img-circle">
                                <img v-else :src="'static/img/noImage.png'" alt="image" class="img-circle">
                              </span>
                              <div class="search-userinfo">
                                <span class="search-username">{{ user.userInfo.userName }}</span>
                                <span class="search-userdept">{{ user.userInfo.dept }}</span>
                              </div>
                            </div>
                          </router-link>
                        </li>
                      <!-- </transition-group> -->
                    </ul>
                </div>
                <!-- /ユーザー検索ボックス -->
            </div>
        </div>
        <!-- /1on1item -->
      </section>
    </article>

      <!-- DetailView -->
      <div id="detailView" class="sub-column" :class="{ 'sub-active' : open }">
        <article class="sub-content-wrap">
          <section>

          </section>
        </article>
      </div>
    </div>
  </div>
</template>

<script>
import CommonJs from '@/js/common'
import { mapGetters } from 'vuex'

export default {
  name: 'UserSearch',
  mixins: [CommonJs],
  components: {
    // ViewTitle
  },
  data: function () {
    return {
      tag: {
        name: 'People',
        src: 'people',
        status: 'progress'
      },
      open: false,
      searchText: '',
      result: false,
      // undefind: false,
      userList: {}
    }
  },
  computed: {
    isMatchPath () {
      return this.$route.name === 'UserSearch'
    },
    ...mapGetters([
      'getUserId',
      'getCurrentUser'
    ]),
    ...mapGetters('users/', [
      'getUsersByText',
      'getUsersByIds',
      'getUserNameKeys',
      'getUsers',
      'getUserInfoById'
    ]),
    ...mapGetters('_meta', [
      'getMetaIsDeleted'
    ]),
    getVisitedUsers: function () {
      const currentUser = this.getCurrentUser
      console.log('currentUser', currentUser)
      if (currentUser && currentUser.hasOwnProperty('visitHistory')) {
        console.log('in if getVisit')
        // return this.getUsersByIds(Object.keys(currentUser.visitHistory))
        const visitHistory = Object.keys(currentUser.visitHistory || [])
        const recentlyCheckedUsers = this.getUsersByIds(visitHistory)
        let sortedRecentlyCheckedUsers = visitHistory.sort((a, b) => { return currentUser.visitHistory[b] - currentUser.visitHistory[a] }).map(x => { return recentlyCheckedUsers[x] })
        for (const [index, value] of visitHistory.entries()) {
          if (this.getMetaIsDeleted(value)) {
            sortedRecentlyCheckedUsers.splice(index, 1)
          }
        }
        return sortedRecentlyCheckedUsers
      } else {
        console.log('in else getVisit')
        return {}
      }
    },
    getUsersBySearchText: function () {
      if (this.searchText.length === 0) {
        this.usersForRelation = this.getUsers
        return this.getUsers
      } else {
        this.usersForRelation = this.getUsersByText(this.searchText)
        let searchResult = this.getUsersByText(this.searchText)
        for (const key of Object.keys(searchResult)) {
          if (searchResult[key] && this.getMetaIsDeleted(key)) {
            delete searchResult[key]
          }
        }
        return searchResult
      }
    },
    getSearchResult () {
      var searchResult = {}
      // 検索処理
      for (let userId in this.getUserNameKeys) {
        // console.log('in for searchTexts out of if=', this.searchText)
        // 検索キーワードがヒットしない場合には-1が返る
        if (this.getUserNameKeys[userId].search(this.searchText) > -1) {
        // ヒットしたオブジェクトをセットする
          searchResult[userId] = this.getUserInfoById(userId)
          // console.log('in for searchTexts=', this.searchText)
        }
      }
      if (Object.keys(searchResult).length > 0) {
        delete searchResult['.key']
        console.log('検索結果 = ', searchResult)
        // console.log('in if searchTexts=', this.searchText)
        this.result = true
        return searchResult
      } else {
        console.log('Not undefind...')
        // console.log('in else searchTexts=', this.searchText)
        searchResult['none'] = this.$t('notFoundUserStr')
        this.result = false
        return searchResult
      }
    }
  },
  methods: {
    onClickResult: function (user) {
      if (user.none) {
      } else {
        this.open = true
      }
    }
  }
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .search-resultview ul li div:hover{
    opacity: 0.7;
  }
</style>



// WEBPACK FOOTER //
// src/views/people/UserSearch.vue